import type { Template } from "@suse-o11y/template";
import type { TemplateVariableDefinitions } from "@suse-o11y/template-variables/definitions";

import { generateVariableNames } from "./generate-variable-names";

export const interpolate = (
	definitions: TemplateVariableDefinitions,
	omittedVariableName: string,
	template: Template<["${", "}"], null>,
) =>
	template.interpolate(definitions.values, {
		whenVariableMissing: undefined,
		omit: generateVariableNames(omittedVariableName),
	});
